export default __webpack_public_path__ + "static/media/Necklace of Tireless Sagacity.7e84cccb.jpg";